import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { POLICY_NAME } from '../POLICY';
import { useTranslation } from 'react-i18next';
import useNotify from '../../../context/Notification/useNotify';
import { useState } from 'react';
import { BackTop, Form, Progress } from 'antd';
import { INIT } from './components/init';
import { useBlocker } from '../../../util/usePrompt';
import { useEffect } from 'react';
import GlobalService from '../../../services/Global.service';
import ModalDiscardChanges from '../../../components/Shared/modal/discardChanges';
import classNames from 'classnames';
import StepList from './components/StepList';
import { ROUTER } from '../../../constants/router';
import { Fragment } from 'react';
import IconBack from '../../../assets/Images/icons/icon-back';
import DPAService from '../../../services/DPA.service';
import moment from 'moment';
import StepWizard from 'react-step-wizard';
import Step1 from './components/Step1';
import Step2 from './components/Step2';
import StepPreview from './components/StepPreview';
import { convertToISODateTime } from '../../../util/util';

const { Provider } = Form;

export default function DataProcessingDetail() {
    const { t } = useTranslation(['translation', POLICY_NAME.DPA]);
    let navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const notify = useNotify();

    const [state, updateState] = useState();

    const [currentSelectList, setCurrentSelectList] = useState(1);

    const [loading, setLoading] = useState(false);
    const [loading_, setLoadingSave] = useState(false);
    const [loadingSaveDraft, setLoadingSaveDraft] = useState(false);
    const [fixed, setFixed] = useState(false);

    // form
    const [requiredInformation] = Form.useForm();
    const [documentContent] = Form.useForm();

    const [previewData, setPreviewData] = useState(INIT);

    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);

    const [dsType, setDsType] = useState([]);

    const [step1, setStep1] = useState(false);
    const [step2, setStep2] = useState(false);

    useBlocker((nextLocation) => onChangePage(nextLocation), change);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };

    const handelOk = () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        await setOpenChange(false);
        await setChange(false);
        await setIsChangeLocation(false);
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    useEffect(() => {
        const current = location.hash.replace('#step', '');
        if (current) {
            setCurrentSelectList(Number(current));
        }
        if (current === '3') {
            setFixed(false);
        }
    }, [location]);

    const setInstance = (SW) => {
        updateState({
            ...state,
            SW,
        });
    };

    const getDPA = async (id) => {
        try {
            setLoading(true);
            const { data } = await DPAService.getDPADetail(id);
            if (data.resultData) {
                const data_ = data?.resultData;
                const effDate = convertToISODateTime(
                    data_.requiredInformation?.contractDate
                );
                const dpaPolicyDataSubjectType =
                    data_.requiredInformation.dpaPolicyDataSubjectType.map(
                        (ds) => ds.dpaDataSubjectId
                    );
                const contractDate = data_.requiredInformation?.contractDate
                    ? moment(effDate)
                    : moment();

                requiredInformation.setFieldsValue({
                    ...data_?.requiredInformation,
                    dpaPolicyDataSubjectType,
                    contractDate,
                });
                documentContent.setFieldsValue(data_?.documentContent);
                setPreviewData(data_);
                setLoading(false);
                setTimeout(() => setChange(false), 1000);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    const getDsTypeDropdown = async () => {
        try {
            const { data } = await GlobalService.getDs();
            if (data?.resultData) {
                setDsType(data?.resultData?.dataSubjectType);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const genaratePayload = async (name, isPublish) => {
        if (!isPublish) setLoadingSaveDraft(true);
        else setLoadingSave(true);

        setChange(false);
        setOpenChange(false);

        let values = {
            requiredInformation: requiredInformation.getFieldsValue(),
            documentContent: documentContent.getFieldsValue(),
        };

        let dpaPolicyDataSubjectType = [];

        const dsTypeGroup =
            values.requiredInformation?.dpaPolicyDataSubjectType;

        if (dsTypeGroup) {
            const dsTypefilter = dsType.filter((ds) =>
                dsTypeGroup.includes(ds.id)
            );
            dpaPolicyDataSubjectType = dsTypefilter.map((ds) => {
                return {
                    dpaDataSubjectId: ds.id,
                    dpaDataSubjectNameTh: ds.nameTh,
                    dpaDataSubjectNameEn: ds.nameEn,
                };
            });
        }

        const contractDate = values.requiredInformation?.contractDate
            ? moment(values.requiredInformation?.contractDate).valueOf()
            : null;

        const dpaDetailDocument =
            values.documentContent.dpaDetailDocument?.replace(
                /class="ql-align-center"/g,
                'style="text-align:center"'
            );

        let payload = {
            documentContent: {
                dpaDetailDocument,
            },
            requiredInformation: {
                ...values.requiredInformation,
                dpaPolicyDataSubjectType,
                contractDate,
                isPublish,
            },
        };

        try {
            const { data } = await DPAService.saveDPA(payload);
            if (data.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('Successfully saved data'),
                });
                if (name === 'preview') {
                    navigate(`${ROUTER.POLICY.DEFAULT}?tab=${POLICY_NAME.DPA}`);
                }

                if (!isPublish) {
                    const dpaPolicyId = data?.resultData?.dpaPolicyId;
                    const hash = window.location.hash;
                    navigate(ROUTER?.POLICY?.DPA + `/${dpaPolicyId}${hash}`);
                    getDPA(dpaPolicyId);
                }
                setLoadingSave(false);
                setLoadingSaveDraft(false);
            }
        } catch (error) {
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
            setLoadingSave(false);
            setLoadingSaveDraft(false);
            console.log(error);
        }
    };

    const saveDraft = () => {
        genaratePayload(null, false);
    };

    const onFormFinish = (name, _) => {
        genaratePayload(name, true);
    };

    useEffect(() => {
        setLoading(true);
        if (id !== 'new') getDPA(id);
        getDsTypeDropdown();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const onFormChange = (name, info) => {
        if (info.changedFields.length > 0) {
            setChange(true);
        }
    };

    const steps = [step1, step2];
    const stepPreview = steps.length + 1;
    const passStep = steps.every((step) => step === true);
    const filter = steps.filter(Boolean).length;
    const currentProgress = ((filter * 100) / steps.length).toFixed(0);
    const stepObject = steps.reduce((result, step, index) => {
        const stepName = `step${index + 1}`;
        return { ...result, [stepName]: step };
    }, {});

    return (
        <Fragment>
            <div className="title flex items-center">
                <div
                    className="cursor-pointer mr-3 space-x-2"
                    onClick={() => {
                        navigate(
                            `${ROUTER.POLICY.DEFAULT}?tab=${POLICY_NAME.DPA}`
                        );
                    }}
                >
                    <IconBack />
                    <span>
                        {id === 'new'
                            ? t('Add Data Processing Agreement', {
                                  ns: POLICY_NAME.DPA,
                              })
                            : t('Edit Data Processing Agreement', {
                                  ns: POLICY_NAME.DPA,
                              })}
                    </span>
                </div>
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Policy')} /{' '}
                    {t('Data Processing Agreement', {
                        ns: POLICY_NAME.DPA,
                    })}{' '}
                    /{' '}
                </span>
                <span>
                    {id === 'new'
                        ? t('Add Data Processing Agreement', {
                              ns: POLICY_NAME.DPA,
                          })
                        : t('Edit Data Processing Agreement', {
                              ns: POLICY_NAME.DPA,
                          })}
                </span>
            </div>
            <div className="mt-4 grid grid-cols-4 gap-4">
                {currentSelectList !== stepPreview && (
                    <StepList
                        steps={stepObject}
                        setCurrentSelectList={() => {
                            // cannot move sp5
                        }}
                        SW={state?.SW}
                        currentSelectList={currentSelectList}
                        setFixed={setFixed}
                    />
                )}
                <div
                    className={classNames({
                        'col-span-3': currentSelectList !== stepPreview,
                        'col-span-4': currentSelectList === stepPreview,
                    })}
                >
                    {currentSelectList !== stepPreview && (
                        <div className="bg-white rounded-md p-4 flex font-semibold text-base">
                            <div className="flex-1 -mt-0.5">
                                <Progress
                                    strokeColor={{
                                        '0%': '#4ACE8F',
                                        '100%': '#4ACE8F',
                                    }}
                                    percent={currentProgress}
                                    status="active"
                                    showInfo={false}
                                />
                            </div>
                            <span
                                className={`pl-6 pr-2 ${
                                    currentProgress === 0
                                        ? 'text-red-500'
                                        : 'text-green-400'
                                }`}
                            >
                                {currentProgress}% {t('succeed')}
                            </span>

                            <span>{t('filledinformation')}</span>
                        </div>
                    )}
                    <Provider
                        onFormChange={onFormChange}
                        onFormFinish={onFormFinish}
                    >
                        <div className="mt-4 bg-white rounded-md p-4 overflow-hidden">
                            <StepWizard
                                isHashEnabled
                                instance={setInstance}
                                onStepChange={(e) => {
                                    setCurrentSelectList(e.activeStep);
                                }}
                            >
                                <Step1
                                    loadingSaveDraft={loadingSaveDraft}
                                    setStep1={setStep1}
                                    loading={loading_}
                                    form={requiredInformation}
                                    previewData={previewData}
                                    dsType={dsType}
                                    saveDraft={saveDraft}
                                />
                                <Step2
                                    requiredInformation={requiredInformation.getFieldsValue()}
                                    passStep={passStep}
                                    loadingSaveDraft={loadingSaveDraft}
                                    setStep2={setStep2}
                                    previewData={previewData}
                                    loading={loading_}
                                    form={documentContent}
                                    saveDraft={saveDraft}
                                />
                                <StepPreview
                                    loading_={loading_}
                                    loadingSaveDraft={loadingSaveDraft}
                                    loading={loading}
                                    previewData={previewData}
                                    forms={{
                                        requiredInformation,
                                        documentContent,
                                    }}
                                    privacyNoticeId={id}
                                    saveDraft={saveDraft}
                                    dsType={dsType}
                                />
                            </StepWizard>
                        </div>
                    </Provider>
                </div>
            </div>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
            <BackTop>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </Fragment>
    );
}

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};
